import { render } from "./App.vue?vue&type=template&id=eea5effa"
const script = {}

import "./App.vue?vue&type=style&index=0&id=eea5effa&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__